// Legal pages (Terms, Privacy, Cookies), legal footer links and the storage notice
const en = {
  "legal.center": "Legal",
  "legal.terms": "Terms",
  "legal.privacy": "Privacy",
  "legal.cookies": "Cookies",
  "legal.termsFull": "Terms of Service",
  "legal.privacyFull": "Privacy Policy",
  "legal.cookiesFull": "Cookie Policy",
  "legal.cookiePolicy": "Cookie Policy",
  "legal.lastUpdated": "Last updated: {date}",
  "legal.onThisPage": "On this page",
  "legal.englishShown": "This document is available in English and Turkish. You're viewing the English version.",
  "legal.questions": "Questions about this document?",
  "legal.questionsDesc": "Contact us at",
  "legal.print": "Print / save as PDF",
  "legal.language": "Language",
  "legal.dashboard": "Dashboard",
  "legal.login": "Sign in",
  "legal.registeredIn": "Registered in {place}.",
  "legal.entityName": "Company",
  "legal.entityRegisteredIn": "Registered in",
  "legal.entityNumber": "Company number",
  "legal.entityOffice": "Registered office",
  "legal.entityIco": "ICO registration",
  "legal.entityContact": "Contact",
  "legal.noticeTitle": "Your privacy",
  "legal.noticeBody": "We only use strictly necessary browser storage to keep you signed in, protect the site and remember choices like your language and theme. We don't use advertising or analytics cookies.",
  "legal.noticeOk": "OK",
};

const tr = {
  "legal.center": "Yasal",
  "legal.terms": "Şartlar",
  "legal.privacy": "Gizlilik",
  "legal.cookies": "Çerezler",
  "legal.termsFull": "Hizmet Şartları",
  "legal.privacyFull": "Gizlilik Politikası",
  "legal.cookiesFull": "Çerez Politikası",
  "legal.cookiePolicy": "Çerez Politikası",
  "legal.lastUpdated": "Son güncelleme: {date}",
  "legal.onThisPage": "Bu sayfada",
  "legal.englishShown": "Bu belge İngilizce ve Türkçe olarak sunulmaktadır. İngilizce sürümü görüntülüyorsunuz.",
  "legal.questions": "Bu belgeyle ilgili sorunuz mu var?",
  "legal.questionsDesc": "Bize şu adresten ulaşın:",
  "legal.print": "Yazdır / PDF olarak kaydet",
  "legal.language": "Dil",
  "legal.dashboard": "Panel",
  "legal.login": "Giriş yap",
  "legal.registeredIn": "{place} sicilinde kayıtlıdır.",
  "legal.entityName": "Şirket",
  "legal.entityRegisteredIn": "Kayıt yeri",
  "legal.entityNumber": "Şirket numarası",
  "legal.entityOffice": "Kayıtlı adres",
  "legal.entityIco": "ICO kayıt numarası",
  "legal.entityContact": "İletişim",
  "legal.noticeTitle": "Gizliliğin",
  "legal.noticeBody": "Oturumunu açık tutmak, siteyi korumak ve dil ile tema gibi tercihlerini hatırlamak için yalnızca zorunlu tarayıcı depolamasını kullanıyoruz. Reklam veya analiz çerezi kullanmıyoruz.",
  "legal.noticeOk": "Tamam",
};

const es = {
  "legal.center": "Legal",
  "legal.terms": "Términos",
  "legal.privacy": "Privacidad",
  "legal.cookies": "Cookies",
  "legal.termsFull": "Términos del servicio",
  "legal.privacyFull": "Política de privacidad",
  "legal.cookiesFull": "Política de cookies",
  "legal.cookiePolicy": "Política de cookies",
  "legal.lastUpdated": "Última actualización: {date}",
  "legal.onThisPage": "En esta página",
  "legal.englishShown": "Este documento está disponible en inglés y turco. Estás viendo la versión en inglés.",
  "legal.questions": "¿Tienes preguntas sobre este documento?",
  "legal.questionsDesc": "Escríbenos a",
  "legal.print": "Imprimir / guardar como PDF",
  "legal.language": "Idioma",
  "legal.dashboard": "Panel",
  "legal.login": "Iniciar sesión",
  "legal.registeredIn": "Registrada en {place}.",
  "legal.entityName": "Empresa",
  "legal.entityRegisteredIn": "Registrada en",
  "legal.entityNumber": "Número de empresa",
  "legal.entityOffice": "Domicilio social",
  "legal.entityIco": "Registro ICO",
  "legal.entityContact": "Contacto",
  "legal.noticeTitle": "Tu privacidad",
  "legal.noticeBody": "Solo usamos el almacenamiento del navegador estrictamente necesario para mantener tu sesión, proteger el sitio y recordar opciones como tu idioma y tema. No usamos cookies de publicidad ni de analítica.",
  "legal.noticeOk": "Entendido",
};

export default { en, tr, es };
